import React from 'react';
import PropTypes from 'prop-types';

import { bemGenerator } from '@prisjakt/ui-base';
import Spinner from '@prisjakt/ui-spinner';

import './index.scss';

const styles = bemGenerator('search-result-list', ['item', 'item-button']);

const SearchResultList = ({
  result,
  showEmptyMessage,
  connectedToInput,
  isLoading,
  onSelect,
  emptyMessage,
  getResultKey,
  formatResult,
  className,
}) => {
  const isEmpty = !result || !result.length;
  if (isEmpty && !showEmptyMessage) {
    return null;
  }
  return (
    <ul
      className={`${className} ${styles.block.withModifier({
        empty: isEmpty,
        loading: isLoading,
        'connected-to-input': connectedToInput,
      })}`}
    >
      {isEmpty ? (
        <li className={styles.item} key="empty">
          {isLoading ? <Spinner size={24} isActive /> : emptyMessage}
        </li>
      ) : (
        result.map((item, i) => (
          <li
            className={styles.item}
            key={getResultKey(item) || `search-result-${i}`}
          >
            <button
              type="button"
              onClick={() => onSelect(item)}
              className={styles['item-button']}
            >
              {formatResult(item)}
            </button>
          </li>
        ))
      )}
    </ul>
  );
};

const { arrayOf, object, bool, node, func, string } = PropTypes;

SearchResultList.propTypes = {
  result: arrayOf(object),
  showEmptyMessage: bool,
  connectedToInput: bool,
  isLoading: bool,
  onSelect: func,
  emptyMessage: node,
  formatResult: func,
  getResultKey: func,
  className: string,
};

SearchResultList.defaultProps = {
  result: [],
  showEmptyMessage: false,
  connectedToInput: false,
  isLoading: false,
  onSelect: () => {},
  emptyMessage: undefined,
  formatResult: item => (item && item.name ? item.name : item),
  getResultKey: item =>
    ['id', 'key'].reduce((selected, key) => selected || item[key]),
  className: '',
};

export default SearchResultList;
